import { Component, OnInit } from '@angular/core';
import { CasinoComponent } from '../dashboard/casino/casino.component';

@Component({
  selector: 'app-casino-detail',
  templateUrl: './casino-detail.component.html',
  styleUrls: ['./casino-detail.component.css']
})
export class CasinoDetailComponent extends CasinoComponent implements OnInit {
  public gameName: string = '';
  public iframeUrl: any = '';
  public gameId: any = '';
  public id: any = '';
  public gameCode: any = '';
  public settings: any = '';

  ngOnInit(): void {
    this.gameId = this.actRoute.snapshot.paramMap.get('cgameId');
    this.gameCode = this.actRoute.snapshot.paramMap.get('cgameCode');
    this.id = Number(this.actRoute.snapshot.paramMap.get('id'));
    this.isMobile = this.width < this.mobileWidth ? true : false;

    if (this.id == '99999') {
      this.getData();
    } else if (this.id == '99995') {
      this.IcasinoIframe();
    }
  }

  ngAfterContentChecked() {
    if (this.id == '99999') {
      this.casinoIframe();
    }
  }

  casinoIframe() {
    this.data?.event_types.forEach((element: any) => {
      if (element.id == this.gameId)
        this.gameName = element.name
    });

    this.settings = this.data?.settings;
    if (this.data?.mobile_link) {
      let lId: any = this.data?.launch_ids ? this.data?.launch_ids[this.gameId] : this.gameId;
      if (this.isMobile) {
        this.iframeUrl = (this.gameId == '99999') ? this.data.mobile_link : `${this.data.mobile_link}/${lId}`
      } else {
        this.iframeUrl = (this.gameId == '99999') ? this.data.web_link : `${this.data.web_link}/${lId}`
      }
      // this.iframeUrl = this._common.secureUrl(this.iframeUrl);

    }
  }

  IcasinoIframe() {
    this.isLoad = true;
    this.getServices().Get(`${this.env.baseUrl + this.api.casinoITbl}/${this.gameId}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.iframeUrl = res.data.iframe;
          this.gameName = res.game_name;
          this.settings = res.data.settings;
        }
        this.isLoad = false;
      },
      (err) => {
        this.isLoad = false;
        console.log(err);
      });
  }

  back() {
    this.router.navigate(['/dashboard'])
  }


}
